import { render, staticRenderFns } from "./EmployeeTagModalNew.vue?vue&type=template&id=bda0d424"
import script from "./EmployeeTagModalNew.vue?vue&type=script&lang=ts"
export * from "./EmployeeTagModalNew.vue?vue&type=script&lang=ts"
import style0 from "./EmployeeTagModalNew.vue?vue&type=style&index=0&id=bda0d424&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bda0d424')) {
      api.createRecord('bda0d424', component.options)
    } else {
      api.reload('bda0d424', component.options)
    }
    module.hot.accept("./EmployeeTagModalNew.vue?vue&type=template&id=bda0d424", function () {
      api.rerender('bda0d424', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/employee/EmployeeTagModalNew.vue"
export default component.exports